import React from "react";
import { NavigationDots, SocialLinks } from "../components/";

const MainPageWrap = (Component, idName, classNames) => {
  return function HOC(props) {
    return (
      <section id={idName} className={`mainpage__section ${classNames}`}>
        <div className="mainpage__container">
          <SocialLinks />
          <div className="mainpage__component">
            <Component {...props} />
            <div className="copyright">
              <p className="p-text">&#169;2022 mun-a</p>
              <p className="p-text">All rights reserved</p>
            </div>
          </div>
          <NavigationDots active={idName} />
        </div>
      </section>
    );
  };
};

export default MainPageWrap;
